import React from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { PlayCircle } from "lucide-react";
import { useSite } from "@/lib/site";

export const VideoSection = () => {
  const site = useSite();
  return (
    <section className="surface-tint">
      <div className="container-wide py-16 lg:py-24">
        <div className="grid gap-10 lg:grid-cols-12 items-center">
          <div className="lg:col-span-5">
            <SectionHeader eyebrow="Watch" title="90 seconds of impact, 2026." lead="A short film from our newsroom — flood relief, learning centres, medical camps and the citizens whose lives are changing." />
          </div>
          <div className="lg:col-span-7">
            <Reveal>
              <Dialog>
                <DialogTrigger asChild>
                  <button data-testid="impact-video-open-button" className="group relative w-full aspect-video rounded-2xl overflow-hidden border border-[hsl(var(--border))] focus-ring">
                    <img src={site.video_poster_url} alt="CAF Impact Reel poster" className="h-full w-full object-cover" />
                    <div className="absolute inset-0 bg-[hsl(var(--navy))]/25 group-hover:bg-[hsl(var(--navy))]/35 transition-colors" />
                    <div className="absolute inset-0 grid place-items-center"><PlayCircle className="h-20 w-20 text-white/95" /></div>
                    <div className="absolute bottom-4 left-4 text-white text-sm bg-black/60 px-3 py-1.5 rounded">{site.video_caption}</div>
                  </button>
                </DialogTrigger>
                <DialogContent className="max-w-4xl p-0 overflow-hidden bg-black">
                  <div className="aspect-video"><iframe title="CAF Impact Reel" className="w-full h-full" src={site.video_embed_url} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></div>
                </DialogContent>
              </Dialog>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
